export enum TopSongsPeriod {
  "OneDay" = "OneDay",
  "SevenDays" = "SevenDays",
  "TwentyEightDays" = "TwentyEightDays",
  "OneMonth" = "OneMonth",
  "OneYear" = "OneYear",
  "AllTime" = "AllTime"
}